// extracted by mini-css-extract-plugin
module.exports = {"map":"Divider_map__1CXP-","wrapper":"Divider_wrapper__1cPhd","black":"Divider_black__21BB2","emph":"Divider_emph__eQEQ0","opaque":"Divider_opaque__3cbba"};